module.exports = __webpack_public_path__ + "0ba27faee29bcc2d54d3b7b566c4265b.png";